import { useEffect, useState } from "react";
import { FormItem, useForm } from "../common/useForm";
import { CancelSurveyState } from "./useCancelSurvey";

// form要素を示すschema。詳しくは./hooks/common/useForm.tsを参照
const initialSchema: FormItem[] = [
  {
    type: 'checkbox',
    name: 'selected',
    value: [],
    validate: (value) => {
      const v = value as string;
      return v.length > 0;
    },
    error: '最低でも一つは選択が必要です。',
    items: []
  },
  {
    type: 'textarea',
    name: 'extraField',
    value: '',
    placeholder: 'こちらにご記入',
  },
];

export const useSubscriptionCancelForm = (
  cancelSurvey: CancelSurveyState,
) => {
  const [schema, setSchema] = useState<FormItem[]>(initialSchema);

  // initialSchema[0].itemsの中身はcancelSurveyに依存している
  // そのため、cancelSurveyの値が確定したタイミングでschema[0].itemsを更新する
  useEffect(() => {
    if (!cancelSurvey) return;
    setSchema(schema.map((el, index) => {
      if (index == 0) return { 
        ...el,
        items: cancelSurvey.reasons.map(item => ({ checked: false, value: item.text})),
        // 管理画面で解約理由選択を必須にした場合はvalidateを保持する(すなわち入力必須になる)
        // チェックが外れている場合はundefinedを代入し、入力必須を無効化する
        validate: cancelSurvey.cancelSurveyRequire ? el.validate : undefined
      }
      return el
    }));
  }, [cancelSurvey]);

  return useForm(schema);
};